import "@/assets/css/animation.less"
import "@/assets/css/style.less"
import $ from 'jquery'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import "@/assets/css/quill.snow.css"
// Vue.component('VNav', (resolve) => {
// 	require(['@/components/VNav.vue'], resolve)
// });
const requireComponents = require.context('./components/', false, /\.vue$/);
requireComponents.keys().forEach(fileName => {
	const componentName = fileName.replace(/\.vue$/i, "").replace(/\.\//, "");
	Vue.component(componentName, (resolve) => {
		require(["@/components/" + fileName.replace(/\.\//, "")], resolve)
	});
});
window.$ = $;
const config = {
	//192.168.1.58:9191,172.17.0.205/v1,219.147.15.157:8086/v1
	apiBase: document.querySelector("[apiBase]").getAttribute("apiBase")
}
Object.defineProperty(Array.prototype, "add", {
	enumerable: false,
	value: function (v) {
		if (this.indexOf(v) == -1) {
			this.push(v);
		}
		return this;
	}
});

Object.defineProperty(Object.prototype, "clone", {
	enumerable: false,
	writable: true,
	value: function () {
		return JSON.parse(JSON.stringify(this));
	}
});
Vue.directive("int", {
	inserted(el, binding, vnode) {
		$(el).on("keydown", function (e) {
			if (isNaN(Number(e.originalEvent.key)) && e.originalEvent.key != "Backspace" && e.keyCode != '37' && e.keyCode != '39' && e.keyCode != '9' || e.originalEvent.key == " ") {
				return false;
			}
		});
	}
});
// 放大图片
Vue.directive("image", {
	inserted(el, binding, vnode) {
		$(el).css("cursor", "pointer");
		$(el).click(function (e) {
			e.stopPropagation();
			var index = 0;
			var zoom = 1;
			var length = binding.value.length;
			var copy = $("<div class='zoom-img'><img src='" + binding.value[index] + "'></div>");
			if (binding.value.length > 1) {
				copy.append(`<div class='controls'><button class='prev switch'></button><span class='index'>1/${length}</span><button class='next switch'></button></div>`);
			}
			var img = $("img", copy);
			var prev = $(".prev", copy);
			var next = $(".next", copy);
			var indexEle = $(".index", copy);
			copy.on("wheel", function (e) {
				e.preventDefault();
			}).on("click contextmenu", function () {
				img.css({
					transition: "",
				});
				copy.addClass("remove");
				setTimeout(function () {
					copy.remove();
				}, 500);
			});
			prev.on("mousedown", (e) => {
				e.preventDefault()
			}).on("click", (e) => {
				if (index == 0) {
					index = length - 1;
				} else {
					index--;
				}
				indexEle.text((index % length + 1) + "/" + length);
				img[0].src = binding.value[index % length];
				copy[0].className = "zoom-img";
				e.stopPropagation();
			});
			next.on("mousedown", (e) => {
				e.preventDefault()
			}).on("click", (e) => {
				index++;
				indexEle.text((index % length + 1) + "/" + length);
				img[0].src = binding.value[index % length];
				copy[0].className = "zoom-img";
				e.stopPropagation();
			});
			img[0].onload = function () {
				copy.addClass("loaded");
				img.css({
					left: innerWidth / 2 - img[0].width / 2 + "px",
					top: innerHeight / 2 - img[0].height / 2 + "px",
				});
				zoom = 1;
				img.css("transform", "scale(" + zoom + ")");
			};
			img[0].onerror = function () {
				copy.addClass("error");
			}
			$("body").append(copy);
			var mpos = {
				start: {
					x: 0,
					y: 0
				},
				offset: {
					x: 0,
					y: 0
				},
				last: {
					x: 0,
					y: 0
				},
				movable: false,
				left: parseFloat(getComputedStyle(img[0]).left.replace("px", "")),
				top: parseFloat(getComputedStyle(img[0]).top.replace("px", ""))
			};

			var mDown = function (e) {
				e.preventDefault();
				mpos.start.x = e.clientX;
				mpos.start.y = e.clientY;
				mpos.last.x = e.clientX;
				mpos.last.y = e.clientY;
				mpos.movable = true;
				img.css("transition", "left 0s,top 0s,transform .2s");
			}
			var mMove = function (e) {
				if (!mpos.movable) return;
				mpos.offset.x = e.clientX - mpos.last.x;
				mpos.offset.y = e.clientY - mpos.last.y;
				mpos.left += mpos.offset.x;
				mpos.top += mpos.offset.y;
				mpos.last.x = e.clientX;
				mpos.last.y = e.clientY;
				img.css({
					left: "+=" + mpos.offset.x,
					top: "+=" + mpos.offset.y
				});
			};
			var mUp = function () {
				mpos.movable = false;
				img.css("transition", "all .2s");
			};
			img.on("mousedown", mDown).click(function (e) {
				e.stopPropagation()
			});
			img.on("contextmenu", function (e) {
				e.preventDefault()
			});
			img.on("mousewheel wheel", function (e) {
				if (e.originalEvent.deltaY < 0) {
					zoom *= 1.1
				} else {
					zoom *= 0.9
				}
				img.css("transform", "scale(" + zoom + ")");
			})
			copy.off("mousemove").on("mousemove", mMove).off("mouseup").on("mouseup", mUp);
		});
	}
});
Vue.mixin({
	data() {
		return {
			required: {
				main: []
			},
			ajaxStatus: {
				getList: "listReady"
			},
			ajaxQueue: 1,
			pageNum: 1,
			pageSize: 8,
			total: 0,
			isList: false,
			token: sessionStorage.getItem("token"),
		}
	},
	watch: {
		pageNum: function () {
			this.getList && this.getList();
		},
		"$root.language"() {
			// this.getList && this.getList();
			this.getData && this.getData();
		}
	},
	computed: {
		pages: function () {
			return Math.ceil(this.total / this.pageSize);
		},
	},
	methods: {
		lang(v) {
			return (this.$root.langs[v] || [])[this.$root.langMode]
		},

	},
	mounted() {
		function setLoading() {
			[].slice.call(arguments).forEach((v) => {
				if (!v) return;
				let fn = v;
				this[v.fName] = function (arg) {
					this.isList = true;
					this.ajaxStatus.getList = "listWorking";
					$(this.$el).addClass("listWorking").removeClass("listReady").removeClass("listError");
					fn(arg);
					this.isList = false;
				}
			});
		}
		if (this.getList) {
			this.getList.fName = "getList"
		}
		if (this.getData) {
			this.getData.fName = "getData"
		}
		setLoading.call(this, this.getList || this.getData);
	}
});

window.ajax = function (obj) {
	var that = this;
	var vm = this.$root;
	var isList = this.isList;
	if (obj.permission && !vm.hasPermission(obj.permission)) {
		return
	}
	obj.data = obj.data || {};
	obj.data = obj.data.constructor.toString().search('FormData') == -1 ? $.extend({
		pageNum: obj.type ? undefined : that.pageNum,
		language: vm.language,
		// delFlag: "0"
	}, obj.data || {}) : obj.data;

	let token = sessionStorage.getItem("token")
	obj.headers = obj.headers || { Authorization: token || "1" };

	obj.binding && (this.$set(this.ajaxStatus, obj.binding, "working"));
	return $.ajax(
		$.extend({}, obj, {
			url: config.apiBase + obj.url,
			dataType: obj.dataType || "json",
			data: (["put", "post", "delete"].indexOf(obj.type ? obj.type.toLowerCase() : "") != -1 && (obj.url != "/oauth/token") && obj.data.constructor.toString().search('FormData') == -1) ? JSON.stringify(obj.data) : obj.data,
			contentType: (["put", "post", "delete"].indexOf(obj.type ? obj.type.toLowerCase() : "") != -1 && (obj.url != "/oauth/token") && obj.data.constructor.toString().search('FormData') == -1) ? "application/json" : obj.contentType,
			headers: obj.headers,
			success(res) {
				obj.binding && (that.ajaxStatus[obj.binding] = (res.code === 0 ? "success" : "error"));
				obj.success && obj.success(res);
				obj.s && obj.s(res);

				if (!obj.pager) {
					res.total !== undefined && (that.total = res.total);
					res.pageSize !== undefined && (that.pageSize = res.pageSize);
				}
				if (res.code === 1) {
					vm.alert.add(res.msg || '未知错误');
					console.warn(res);
				}
				if (isList) {
					if (res.code === 0) {
						that.ajaxStatus.getList = "listReady";
					} else {
						that.ajaxStatus.getList = "listError";
					}
					$(that.$el).addClass("listReady").removeClass("listWorking").removeClass("listError");
				}
			},
			error(err) {
				obj.binding && (that.ajaxStatus[obj.binding] = "error");
				switch (err.status) {
					case 401:
						vm.alert.add("您未登录或者已在别处登录！");
						sessionStorage.removeItem("token");
						that.token = null;
						vm.$router.push({ path: "/" });
						break;
					case 403:
						vm.alert.add("权限不足！");
						break;
					case 404:
						vm.alert.add("接口不存在：" + obj.url);
						break;
					case 405:
						vm.alert.add("请求方式不被允许！");
						break;
					case 500:
						vm.alert.add((err.responseJSON && err.responseJSON.msg) ? err.responseJSON.msg : "内部服务器错误！");
						break;
					case 502:
						vm.alert.add("服务器重启中！");
						break;
					case 503:
						vm.alert.add("服务器繁忙！");
						break;
					case 0:
						vm.alert.add("服务器未响应！");
						break;
					default:
						vm.alert.add(err.status + "[" + err.statusText + "]");
				}
				obj.error && obj.error(err);
				if (isList) {
					that.ajaxStatus.getList = "listError";
					$(that.$el).addClass("listError").removeClass("listWorking").removeClass("listReady");
				}
			}
		})
	);
}

router.beforeEach((to, from, next) => {
	if (to.path.split("/")[1] != from.path.split("/")[1]) {
		$(window).scrollTop(0);
	}
	next();
});

window.vm = new Vue({
	router,
	render: h => h(App),
	data: {
		alert: [],
		alertAuto: false,
		confirm: [],
		prompt: [],
		langs: {
			more: ["查看更多", "More"],
			nav_index: ["首页", "Home"],
			nav_about: ["关于贤俊龙", "About"],
			nav_about_intro: ["贤俊龙介绍", "Introduction"],
			nav_about_idea: ["公司理念", "Philosophy"],
			nav_about_honor: ["荣誉资质", "Honor"],
			nav_about_history: ["发展历程", "History"],
			nav_about_distribution: ["全国分布", "Distribution"],
			nav_tech: ["工艺技术", "Technology"],
			nav_tech_patented: ["专利工艺", "Patented"],
			nav_tech_special: ["特种工艺", "Special"],
			nav_tech_certification: ["体系认证", "System certification"],
			nav_tech_laboratory: ["贤俊龙实验室", "Laboratory"],
			nav_video: ["内部视频", "Internal Video"],
			nav_products: ["产品与服务", "Products"],
			nav_company: ["旗下子公司", "Subsidiary"],
			nav_pro_display: ["产品展示", "Product Display"],
			nav_pro_equipment: ["设备介绍", "Equipment"],
			nav_pro_printing: ["我们的服务", "Printing Services"],
			nav_pro_characteristic: ["公司特色", "Characteristic"],
			nav_news: ["新闻动态", "News"],
			nav_print: ["在线印刷", "Printing"],
			nav_digital_print: ["数码印刷", "Digital Printing"],
			nav_Traditional_print: ["传统印刷", "Traditional Printing"],
			nav_index_recruit: ["招贤纳士", "Recruitment"],
			nav_index_display: ["产品展示", "Product Display"],
			nav_human: ["联系我们", "Contact Us"],
			about_intro: ["公司简介", "Introduction"],
			about_advantage: ["公司优势", "Advantage"],
			about_honor: ["公司荣誉", "Honor"],
			about_sc: ["体系认证", "System Certification"],
			about_duty: ["社会责任", "Duty"],
			about_future: ["未来发展", "Company Development"],
			about_future_printing: ["数码印刷", "Digital Printing"],
			about_future_ai: ["二期人工智能", "Phase II AI"],
			about_future_flotation: ["上市", "Flotation"],
			about_intro_intro: ["公司简介", "Introduction"],
			about_intro_intro_print: ["印刷加工", "Printing and Machining"],
			about_intro_intro_mine: ["矿产开发", "Mineral Exploitation"],
			about_intro_intro_hotel: ["酒店", "Hotel"],
			about_intro_intro_net: ["物联网", "Internet of Things"],
			about_intro_intro_export: ["出口贸易", "Export Trade"],
			about_intro_management: ["管理模式", "Management Model"],
			about_intro_distribution: ["产业分布", "Industrial Distribution"],
			about_values: ["核心价值观", "Core Values"],
			tech_advantage: ["优势", "ADVANTAGE"],
			tech_innovation: ["创新", "INNOVATION"],
			tech_innovation_patent: ["专利", "PATENT"],
			tech_advantage_company: ['公司优势', "COMPANY ADVANTAGE"],
			tech_antifake: ['防伪', 'ANTI-COUNTERFEITING'],
			service_device: ["印刷设备", "PRINTING DEVICES"],
			service_software: ["印刷软件", "PRINTING SOFTWARE"],
			service_customer: ["合作客户", "CUSTOMERS"],
			service_printing_before: ["印前", "BEFORE PRINTING"],
			service_printing: ["印刷", "PRINTING"],
			service_printing_after: ["印后", "AFTER PRINTING"],
			service_qc: ["质检", "QUALITY CONTROL"],
			hr_position: ["工作岗位", "JOB TITLE"],
			hr_name: ["职位名称", "JOB NAME"],
			hr_place: ["工作地点", "JOB PLACE"],
			hr_salary: ["薪资待遇", "JOB SALARY"],
			hr_responsibility: ["岗位职责", "JOB RESPONSIBILITIES"],
			hr_type: ["职位类型", "JOB TYPE"],
			hr_hot: ["热招职位", "HOT JOB"],
			hr_request: ["投递简历", "Apply Position"],
			hr_view_apply: ["查看并投递", "View And Apply"],
			hr_check_more: ["查看更多职位", "CHECK MORE JOB"],
			message_title: ["留言板", "MESSAGE BOARD"],
			message_name: ["您的姓名", "Name"],
			message_company: ["单位名称", "Company"],
			message_phone: ["联系电话", "Phone"],
			message_email: ["联系邮箱", "Email"],
			message_content: ["您的留言", "Content"],
			message_submit: ["提交", "SUBMIT"],
			login_title: ["登录", "LOGIN"],
			login_name: ["登录账号", "Username"],
			login_pwd: ["登录密码", "Password"],
			login_submit: ["登录", "SIGN IN"],
			qingdao: ["青岛", "Qingdao"],
			qingdao_xjl: ["青岛市贤俊龙彩印有限公司", "Qingdao Xianjunlong Color Printing Co., Ltd."],
			xian: ["西安", "Xi'an"],
			xian_xjl: ["西安万里鹏城彩印有限公司", "Xi'an Wanlipengcheng Color Printing Co., Ltd."],
			hubei: ["湖北", "Hubei"],
			hubei_xjl: ["湖北浩和智能包装科技有限公司", "Hubei Haohe Intelligent Packaging Technology Co., Ltd."],
			guizhou: ["贵州", "Guizhou"],
			guizhou_xjl: ["贵州贤俊龙彩印有限公司", "Guizhou Xianjunlong Color Printing Co., Ltd."],
			guangzhou: ["广州", "Guangzhou"],
			guangzhou_xjl: ["广州市贤俊龙彩印有限公司", "Guangzhou Xianjunlong Color Printing Co., Ltd."],
			shenzhen: ["深圳", "Shenzhen"],
			shenzhen_xjl: ["深圳市贤俊龙彩印有限公司", "Shenzhen Xianjunlong Color Printing Co., Ltd."],
			shenzhen_hhx: ["深圳市鸿海鑫印刷制品有限公司", "Shenzhen Honghai Xin Printing Products Co., Ltd."],
			shenzhen_ym: ["深圳市优码锐诚数码科技有限公司", "Shenzhen Youmaruicheng Digital Technology Co., Ltd."],
			shanghai_xjl: ["深圳市贤俊龙彩印有限公司上海分公司", "Shenzhen Xianjunlong Color Printing Co., Ltd. Shanghai Branch"],
			dongguan: ['东莞', 'Dongguan'],
			dongguan_xjl: ["东莞市贤俊龙包装科技有限公司", "Dongguan Xian Jun Long packaging technology Co., LTD."],
		},
		// langMode: window.navigator.language.search("CN") != -1 ? 0 : 1,
		langMode: 0,
		siteInfo: {},
		groupId: 1,
		companyList: [],
		banners: [],
		loading: false,
	},
	computed: {
		language() {
			return this.langMode == 0 ? 'CN' : 'EN'
		}
	},
	methods: {
		getSiteInfo() {
			var that = this;
			ajax.call(this, {
				url: "/api/website/info",
				s(res) {
					that.siteInfo = res.data;
					document.title = that.siteInfo.websiteName || "永太和集团";
				}
			});
		},
		getCompanyList(typeId) {
			let that = this;
			ajax.call(this, {
				url: "/company/list",
				data: {
					pageNum: 1,
					pageSize: 999,
				},
				s(res) {
					that.companyList = res.data.map(v => {
						if (typeId > 0) {
							if (v.companyName == "永太和集团") {
								that.groupId = v.id;
								// that.getBanner(typeId);
							}
						}
						return {
							companyName: v.companyName,
							companyNameEnglish: v.companyNameEnglish,
							id: v.id
						}
					});
				}

			});
		},
		getBanner(typeId) {
			var that = this;
			ajax.call(this, {
				url: "/bloc/slideshow/list/language",
				data: {
					// organizationId:that.groupId,
					organizationId: 1,
					// 1首页，2关于贤俊龙，3公司特色，4产品与服务，5工艺技术，6新闻动态，7联系我们，8内部视频
					typeId: typeId
				},
				s(res) {
					that.banners = res.data.map(v => {
						return {
							image: v.slideshowPicture,
							link: v.slideshowUrl,
							loaded: false
						}
					});
				}
			});
		},
	},
	mounted() {
		// this.getSiteInfo();
		document.title = "永太和集团";
		this.getCompanyList(1);
	}
}).$mount('#app')

router.afterEach((to, from) => {
	if (to.path.split("/")[1] != from.path.split("/")[1]) {
		vm.$root.banners = []
	}

	if (to.path == "/video") {
		if (!sessionStorage.getItem("token")) {
			vm.alert.add('您还未登录，暂时无法查看内部视频');
			vm.token = sessionStorage.getItem("token");
			vm.$router.push({ path: "/" });
		}
	}
});
